import {
  Box,
  Button,
  Checkbox,
  Drawer,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  Slide,
  AppBar,
  OutlinedInput,
  Toolbar,
  Typography,
  Skeleton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Controller, useForm, FormProvider } from "react-hook-form";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loadAction } from "redux/reducers/top";
import { makeStyles } from "@mui/styles";
import {
  rem,
  displayTel,
  refreshToken,
  goCert,
  isJsonString,
  maxLen,
} from "assets/js/common";
import axios from "axios";
import Address from "components/ui/join/address";
import AlertConfirm from "components/ui/alert-confirm";
import AlertComplete from "components/ui/alert-complete";
import { Cookies } from "react-cookie";
import { setUserInfoAction } from "redux/reducers/user";

const useStyles = makeStyles((theme) => ({
  privacy: {
    "& .map": {
      display: "none",
      margin: "10px 0",
      position: "relative",
      width: "100%",
      height: "350px",
      scrollY: "auto",
      paddingBottom: "10px",
      "& .clseBtn": {
        textAlign: "right",
        // paddingRight: rem(10),
        "& img": {
          cursor: "pointer",
        },
      },
    },

    "& .ico-go-grey": {
      top: rem(-1),
    },

    "& .marketing-check": {
      "&.MuiFormGroup-row": {
        "& .MuiFormControlLabel-root": {
          marginBottom: rem(10),
          "&:not(:last-of-type)": {
            margin: `0 ${rem(26)} ${rem(10)} 0`,
          },
        },
      },
    },

    "& .form-group-wrap": {
      "& .MuiButton-text": {
        fontSize: rem(14),
      },
    },
    "& .MuiButton-root:hover": {
      backgroundColor: "#ccc",
    },
    "& .MuiCheckbox-root.noborder:hover": {
      background: "none",
    },

    "& .carNo-list": {
      "& li": {
        display: "flex",
        justifyContent: "space-between",
        "& + li": {
          marginTop: rem(17),
        },
      },
    },
  },
}));

const cookies = new Cookies();
export default function Privace() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [userInfo, setUserInfo] = useState("");
  const [dbSubmit, setDbSubmit] = useState(false);

  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [openComp, setOpenComp] = useState(false);
  const [openValid, setOpenValid] = useState(false);
  const [member, setMember] = useState("");
  const [authType, setAuthType] = useState("");
  const [callback, setCallback] = useState("");

  const [carNos, setCarNos] = useState([]);
  const form = useForm({
    defaultValues: {
      nm: "",
      no: "",
      cph: "",
      email: "",
      zip: "", // 우편번호
      addr: "", // 주소
      addrDtl: "", // 상세주소
      carNo: "",
      mktPushYn: "", // 마케팅SMS수신여부
      mktSmsYn: "", // 마케팅PUSH수신여부
      mktEmailYn: "", // 마케팅EMAIL수신여부
      // gnrPushYn: "",
    },
  });

  const handleAlertClose = () => {
    setOpen(false);
  };

  const goAuthPage = (tp) => {
    setAuthType(tp);
    goCert("mypageReturnRunc");
  };

  form.watch("mktSmsYn", false);
  form.watch("mktPushYn", false);
  form.watch("mktEmailYn", false);
  // form.watch("gnrPushYn", false);

  const handleChange = (e) => {
    let name = e.target.name;
    form.setValue(name, e.target.checked);
  };

  const onSubmit = (data) => {
    let arr = data.carNo ? carNos.concat(data.carNo) : carNos;
    console.log("arr", arr);
    if (arr.length > 3) {
      setOpenValid(true);
      return;
    }
    let form = {
      no: userInfo.no,
      zip: data.zip, // 우편번호
      addr: data.addr, // 주소
      addrDtl: data.addrDtl, // 상세주소
      carNo: arr.join(","),
      mktPushYn: data.mktPushYn ? "Y" : "N", // 마케팅SMS수신여부
      mktSmsYn: data.mktSmsYn ? "Y" : "N", // 마케팅PUSH수신여부
      mktEmailYn: data.mktEmailYn ? "Y" : "N", // 마케팅EMAIL수신여부
      // gnrPushYn: data.gnrPushYn ? "Y" : "N",
    };

    setDbSubmit(true);
    axios.post("/api/mb/member/modify", form).then((res) => {
      if (res.data.data) {
        let adYn = form.mktPushYn;
        if (window.Android) {
          window.Android.setPushAdYn(adYn);
        } else if (
          window.webkit &&
          window.webkit.messageHandlers &&
          window.webkit.messageHandlers.ios
        ) {
          // Call iOS interface
          var message = {
            command: "setPushAdYn",
            adYn: adYn,
          };
          window.webkit.messageHandlers.ios.postMessage(message);
        }

        setOpenComp(true);
        setDbSubmit(false);
      }
    });
  };

  const onReset = () => {
    form.reset({
      nm: member.nm,
      no: userInfo.no,
      cph: displayTel(userInfo.cph),
      email: member.email,
      zip: member.zip, // 우편번호
      addr: member.addr, // 주소
      addrDtl: member.addrDtl, // 상세주소
      carNo: "",
      mktPushYn: member.mktPushYn == "Y", // 마케팅SMS수신여부
      mktSmsYn: member.mktSmsYn == "Y", // 마케팅PUSH수신여부
      mktEmailYn: member.mktEmailYn == "Y", // 마케팅EMAIL수신여부
      // gnrPushYn: member.gnrPushYn == "Y",
    });
    let arr = member.carNo ? member.carNo.split(",") : [];
    setCarNos(arr);
  };

  const loadUserInfo = () => {
    axios.get("/api/mb/member/my-info").then((res) => {
      setUserInfo(res.data.data.member);
    });
  };

  const loadData = () => {
    axios.get(`/api/mb/member/get/${userInfo.no}`).then((res) => {
      setMember(res.data.data.member);
    });
  };

  const updateUserInfo = async () => {
    let myDecodedToken = await refreshToken();
    dispatch(setUserInfoAction(myDecodedToken));

    setOpenComp(true);
  };

  const updateUser = async (data) => {
    let form = "";
    if (authType == "nm") {
      form = {
        no: userInfo.no,
        nm: data.name,
      };
    } else {
      form = {
        no: userInfo.no,
        cph: data.cph,
      };
    }

    await axios
      .post("/api/mb/member/modify", form)
      .then((res) => {
        if (res.data.data) {
          updateUserInfo();
        }
      })
      .catch((err) => {});
  };

  const setReturnData = (result) => {
    result = JSON.parse(result);
    if (result.rst == "success" && result.isUser) {
      setCallback(result);
    }
  };

  useEffect(() => {
    console.log("userInfo", userInfo);
    if (userInfo) {
      loadData();
    }
  }, [userInfo]);

  useEffect(() => {
    if (userInfo) {
      onReset();
    }
  }, [member]);

  useEffect(() => {
    if (userInfo && callback) {
      updateUser(callback);
    }
  }, [callback]);

  useEffect(() => {
    window.scrollTo(0, 0);
    loadUserInfo();
    //app return
    window.mypageReturnRunc = (data) => {
      if (data) {
        setReturnData(decodeURI(data));
      }
    };

    //web test
    const receiveMessage = async (e) => {
      if (isJsonString(e.data)) {
        setReturnData(e.data);
      }
    };

    window.addEventListener("message", receiveMessage, false);
  }, []);

  const { init } = useSelector((state) => state.top);
  useEffect(() => {
    if (init)
      dispatch(loadAction({ back: true, title: "개인정보 수정", menu: false }));
  }, [init]);

  window.appBackKeyHandle = () => {
    if (open) {
      handleAlertClose();
    } else {
      history.goBack();
    }
  };

  return (
    <main id="main" className={"container " + classes.privacy}>
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className={classes.step3}>
          <Box className="box-type-1">
            <Grid container spacing={1} className="form-group-wrap" mb={2}>
              <Grid item xs={12} md={6}>
                <FormControl variant="outlined">
                  <InputLabel shrink>이름</InputLabel>
                  <OutlinedInput
                    type="text"
                    {...form.register("nm")}
                    inputProps={{
                      maxLength: 10,
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <Button
                          aria-label="registration"
                          type="button"
                          edge="end"
                          onClick={() => goAuthPage("nm")}
                        >
                          변경
                        </Button>
                      </InputAdornment>
                    }
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControl variant="outlined">
                  <InputLabel shrink>휴대폰 번호</InputLabel>
                  <OutlinedInput
                    type="text"
                    {...form.register("cph")}
                    inputProps={{
                      maxLength: 10,
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <Button
                          aria-label="registration"
                          type="button"
                          edge="end"
                          onClick={() => goAuthPage("cph")}
                        >
                          변경
                        </Button>
                      </InputAdornment>
                    }
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControl variant="outlined">
                  <InputLabel shrink>이메일</InputLabel>
                  <OutlinedInput
                    type="text"
                    {...form.register("email")}
                    endAdornment={
                      <InputAdornment position="end">
                        <Button
                          aria-label="registration"
                          type="button"
                          edge="end"
                          onClick={() => {
                            history.push("/mypage/privacy/email");
                          }}
                        >
                          변경
                        </Button>
                      </InputAdornment>
                    }
                    disabled
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Box>
          <Divider className="divider-type-2" />
          <Box className="box-type-5">
            <Grid container spacing={1} className="form-group-wrap">
              <Grid item xs={12} md={6}>
                <Address />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControl variant="outlined">
                  <InputLabel shrink>차량번호</InputLabel>
                  <OutlinedInput
                    type="text"
                    aria-label="carNo"
                    {...form.register("carNo")}
                    placeholder="차량번호를 입력해주세요."
                    onInput={(e) => {
                      let value = maxLen(e.target.value, 8);
                      form.setValue("carNo", value);
                    }}
                  />
                </FormControl>
              </Grid>
              {carNos.length > 0 && (
                <Grid item xs={12} md={6}>
                  <ul className="carNo-list">
                    {carNos.map((no, i) => (
                      <li key={`${no}${i}`}>
                        {no}
                        <IconButton
                          aria-label="delete"
                          onClick={() => {
                            carNos.splice(i, 1);
                            setCarNos([...carNos]);
                            console.log("nos", i, carNos);
                          }}
                        >
                          <i className="ico-del" />
                        </IconButton>
                      </li>
                    ))}
                  </ul>
                </Grid>
              )}
            </Grid>
          </Box>

          <Divider className="divider-type-2" />

          <Box className="box-type-5" style={{ paddingBottom: 0 }}>
            <Grid container spacing={1} className="form-group-wrap">
              <Grid item xs={12} md={6}>
                <FormControl variant="outlined">
                  <InputLabel shrink>마케팅정보 수신 동의 [선택]</InputLabel>
                  <Box style={{ marginTop: "8px" }}>
                    <FormGroup row className="marketing-check">
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            name="mktSmsYn"
                            icon={<span className="checkbox-icon" />}
                            checkedIcon={
                              <span className="checkbox-icon-checked" />
                            }
                            className="noborder"
                            {...form.register("mktSmsYn")}
                            checked={form.getValues("mktSmsYn")}
                            onChange={handleChange}
                          />
                        }
                        label={<span className="font-14">SMS</span>}
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            name="mktEmailYn"
                            icon={<span className="checkbox-icon" />}
                            checkedIcon={
                              <span className="checkbox-icon-checked" />
                            }
                            className="noborder"
                            {...form.register("mktEmailYn")}
                            checked={form.getValues("mktEmailYn")}
                            onChange={handleChange}
                          />
                        }
                        label={<span className="font-14">이메일</span>}
                      />
                      {/* <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            name="gnrPushYn"
                            icon={<span className="checkbox-icon" />}
                            checkedIcon={
                              <span className="checkbox-icon-checked" />
                            }
                            className="noborder"
                            {...form.register("gnrPushYn")}
                            checked={form.getValues("gnrPushYn")}
                            onChange={handleChange}
                          />
                        }
                        label={<span className="font-14">일반 PUSH</span>}
                      /> */}
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            name="mktPushYn"
                            icon={<span className="checkbox-icon" />}
                            checkedIcon={
                              <span className="checkbox-icon-checked" />
                            }
                            className="noborder"
                            {...form.register("mktPushYn")}
                            checked={form.getValues("mktPushYn")}
                            onChange={handleChange}
                          />
                        }
                        label={<span className="font-14">광고성 PUSH</span>}
                      />
                    </FormGroup>
                  </Box>
                </FormControl>
              </Grid>
            </Grid>

            <Box className="bottom-area" mt={8}>
              <Grid container justifyContent="center" spacing={2}>
                <Grid item>
                  <Button
                    className="btn-cancel"
                    variant="contained"
                    onClick={() => setOpen(true)}
                  >
                    취소
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    color="primary"
                    variant="contained"
                    type="submit"
                    disabled={dbSubmit}
                  >
                    저장
                  </Button>
                </Grid>
              </Grid>
            </Box>

            <Box mt={6}>
              <Link
                to={"/mypage/privacy/leave"}
                className="btn-link color-info font-14"
              >
                회원탈퇴
                <i className="ico-go-grey" />
              </Link>
            </Box>
          </Box>
        </form>
      </FormProvider>
      <AlertConfirm
        open={open}
        handleAlertClose={handleAlertClose}
        text={
          "수정하신 회원 선택정보 내용이 반영되지 않습니다.<br/>그래도 취소하시겠습니까?"
        }
        action={() => history.goBack()}
      />
      {/* <AlertTimer
        open={openComp}
        handleAlertTimerClose={() => {
          setOpenComp(false);
          history.push("/mypage");
        }}
        text={"회원정보가 변경되었습니다."}
      /> */}
      <AlertComplete
        open={openComp}
        handleAlertClose={() => {
          setOpenComp(false);
        }}
        text="회원정보가 변경되었습니다."
        action={() => history.goBack()}
      />
      <AlertComplete
        open={openValid}
        handleAlertClose={() => setOpenValid(false)}
        text="차량번호는 최대 3개까지 등록 가능합니다<br/>등록된 차량번호 개수를 확인해주세요."
        action={() => setOpenValid(false)}
      />
    </main>
  );
}
